module.exports = {
  /* Main app */
  appName : 'Listings Generator',
  title: 'Listings Generator',
  hostname: 'http://localhost:1337',
  exportURL: "http://ec2-3-143-5-240.us-east-2.compute.amazonaws.com/",

  dataSheetID: "1abjlDJjmuAwggB-xNw_s8WK_QoiDK1lz8hXfSu206uY",
  upcSpreadSheetID: '1WMs3Iww-JVVJaW2qeSCI-gkXwdzxMNxZufpo7SeUlm4',
  googleArchiveFolderID: '1YoatdK2unHqAuxmjakrZf4mfeAtA294e',

  googleRefreshToken: '1//04i1HtRLWusr_CgYIARAAGAQSNgF-L9IrEWi1MfQRjtMQdhwVRnG8JvyF81n61wrh3JluEslbqjAnGM6_yfKnnwTecCNcZqolAg',
  googleClientID: '643101473910-1qm4ujd3dehk43lqkiss8ne67la3qhkh.apps.googleusercontent.com',
  googleClientSecret: 'r6THYaotcaQaXDj_WUuiGbD3',

  wipersDataSheetID: '1JJt201fswZzNASaLmn6SdiGx-gqtc3gHbV0JylEVNqU'
};
